module.exports = __webpack_public_path__ + "93a02d2f46b869dedf34e11d567711bc.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/woodcare/efrdxv.png
// module id = 2723
// module chunks = 0